import React from 'react';
import css from './index.module.scss';
import SiteFooter from './SiteFooter';

interface Props {
  merchantPublicId?: string | null;
  onFreePlan?: boolean;
}

const MerchantGlobalFooter: React.FC<Props> = ({
  merchantPublicId,
  onFreePlan,
}) => {
  return (
    <footer className={css.MerchantGlobalFooter}>
      <SiteFooter merchantPublicId={merchantPublicId} onFreePlan={onFreePlan} />
    </footer>
  );
};

export default MerchantGlobalFooter;
